import {
  Apps,
  FormatListBulleted,
  KeyboardArrowDown,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Chip,
  Container,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Pagination,
  Paper,
  Select,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Slider from "react-slick";
import "./HomeSlider.css";
import { useNavigate } from "react-router-dom";
import JobShortCard from "./Latest Job/JobShortCard";
import { jobApi } from "../API/Api";
import { motion } from "framer-motion";
const settings = {
  infinite: true,
  arrows: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  draggable: true,
  dots: false,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const HomePageJobs = () => {
  const navigate = useNavigate();

  const [jobListData, setJobListData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(jobApi)
      .then((res) => res.json())
      .then((result) => {
        setJobListData(result?.slice(0, 5));
        setLoading(false);
      })
      .catch((error) => console.log("JobApiError=> ", error));
  }, []);
  // console.log("jobListDatahhhhhh:", jobListData);

  return (
    <Box sx={{ backgroundColor: "#F2F3F5", py: 5 }}>
      <Container>
        {/* Header */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 1 }}
        >
          <Box>
            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontWeight: 800,
                fontSize: { xs: "26pt", md: "34pt" },
                background: "linear-gradient(to right, #00C9A7, #0074E4)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                letterSpacing: "0.5px",
              }}
            >
              Jobs
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "13pt", md: "15pt" },
                color: "#9E9E9E",
                maxWidth: "600px",
              }}
            >
              Latest job posts curated for you
            </Typography>
          </Box>

          <Button
            variant="contained"
            onClick={() => navigate("/joblist")}
            sx={{
              px: 5,
              py: 1.5,
              fontSize: "16pt",
              fontWeight: 600,
              textTransform: "none",
              background:
                "linear-gradient(135deg, rgba(0,201,167,0.9), rgba(0,116,228,0.9))",
              borderRadius: "50px",
              boxShadow: "0px 8px 24px rgba(0,201,167,0.3)",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)",
                background:
                  "linear-gradient(135deg, rgba(0,201,167,1), rgba(0,116,228,1))",
              },
            }}
          >
            More
          </Button>
          {/* <Button
            variant="outlined"
            sx={{
              fontWeight: 500,
              fontSize: "11pt",
              textTransform: "none",
              borderRadius: "8px",
              borderColor: "#22AB7D",
              color: "#22AB7D",
              "&:hover": {
                backgroundColor: "#22AB7D10",
                borderColor: "#22AB7D",
              },
            }}
            onClick={() => navigate("/joblist")}
          >
            See more...
          </Button> */}
        </Stack>

        <Divider sx={{ mb: 3 }} />

        {/* Slider or Skeleton */}
        {loading ? (
          <Slider {...settings}>
            {[1, 2, 3, 4].map((i) => (
              <Box key={i} sx={{ px: 1, pb: 4 }}>
                <Skeleton variant="rounded" height={180} />
              </Box>
            ))}
          </Slider>
        ) : (
          jobListData[0]?.job_refer && (
            <Slider {...settings}>
              {jobListData.map((job) => (
                <motion.div
                  key={job.job_refer}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  <Box sx={{ px: 1, pb: 4 }}>
                    {/* Job Card with tags */}
                    <Stack
                      spacing={1}
                      sx={{
                        // backgroundColor: "#fff",
                        // borderRadius: 2,
                        // p: 2,
                        // boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
                        minHeight: 180,
                      }}
                    >
                      <JobShortCard jobData={job} />

                      {/* Tag Bar */}
                      {job.job_tags?.length > 0 && (
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                          {job.job_tags.map((tag, i) => (
                            <Chip
                              key={i}
                              label={tag}
                              size="small"
                              sx={{
                                backgroundColor: "#E6F4F1",
                                color: "#22AB7D",
                                fontWeight: 500,
                              }}
                            />
                          ))}
                        </Stack>
                      )}
                    </Stack>
                  </Box>
                </motion.div>
              ))}
            </Slider>
          )
        )}
      </Container>
    </Box>
  );
};

export default HomePageJobs;
